import dayjs from 'dayjs';
import { groupBy, init, takeLast } from 'ramda';

import { EventFragment, EventType } from '../../graphql/generated';
import { formatFilePath } from '../../utils/file/file';

export const formatTimestamp = ({ timestamp }: EventFragment): string =>
  dayjs(timestamp).format('YYYY-MM-DD');

export const groupByDate = (
  events: EventFragment[]
): Record<string, EventFragment[]> => groupBy(formatTimestamp, events);

export const getDateLabel = (dateString: string): string => {
  const date = dayjs(dateString);

  if (date.isToday()) {
    return 'Today';
  }

  if (date.isYesterday()) {
    return 'Yesterday';
  }

  return date.format('MMM DD, YYYY');
};

export const eventTypeMap: Record<EventType, string> = {
  [EventType.FILE_CREATED]: 'uploaded an item to',
  [EventType.FILE_UPDATED]: 'revised an item in',
  [EventType.FILE_ARCHIVED]: 'archived an item in',
  [EventType.FILE_DOWNLOADED]: 'downloaded an item from',
  [EventType.FILE_DELETED]: 'deleted an item from',
  [EventType.FOLDER_CREATED]: 'created a new folder in',
  [EventType.FOLDER_DOWNLOADED]: 'downloaded the folder',
  [EventType.PII_APPROVED]: 'reviewed a file for PII in',
  [EventType.FILE_MOVED]: 'moved a file to',
  [EventType.FILE_RENAMED]: 'renamed a file to',
};

type EventDetails = {
  folder: string;
  filename: string;
  path: string;
};

export const getEventDetails = (
  storageSpaceName: string,
  filepath: string
): EventDetails => {
  let folder = storageSpaceName;
  const path = formatFilePath(filepath);
  const pathParts = path.split('/');
  const filename = takeLast(1, pathParts)[0];
  const pathWithoutFilename = init(pathParts).join('/');

  if (pathParts.length > 1) {
    folder = takeLast(2, pathParts)[0];
  }

  return { path: pathWithoutFilename, folder, filename };
};
